import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../supabase';
import '../styles/Auth.css';

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nombre, setNombre] = useState('');
  const [celular, setCelular] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const getRedirect = () => {
    const params = new URLSearchParams(location.search);
    return params.get('redirect') || '/home';
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: { nombre, celular }
      }
    });

    if (error) {
      setError('Error al registrarse. Intentá de nuevo.');
    } else {
      setMensaje('Te mandamos un mail de verificación. Revisá tu bandeja.');
    }
    setLoading(false);
  };

  const handleGoogleLogin = async () => {
    const redirect = getRedirect();
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `https://vysafe.com${redirect}`,
      },
    });
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1 className="auth-title">VySafe</h1>
        <p className="auth-subtitle">Creá tu cuenta</p>

        {mensaje ? (
          <div className="auth-success">
            <p>{mensaje}</p>
            <p className="auth-link" onClick={() => navigate(getRedirect())}>
              Ir al login
            </p>
          </div>
        ) : (
          <>
            <form onSubmit={handleRegister} className="auth-form">
              <input
                type="text"
                placeholder="Tu nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                className="auth-input"
                required
              />
              <input
                type="email"
                placeholder="Tu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="auth-input"
                required
              />
              <input
                type="tel"
                placeholder="Tu celular"
                value={celular}
                onChange={(e) => setCelular(e.target.value)}
                className="auth-input"
                required
              />
              <input
                type="password"
                placeholder="Elegí una contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="auth-input"
                required
              />
              {error && <p className="auth-error">{error}</p>}
              <button type="submit" className="auth-button" disabled={loading}>
                {loading ? 'Creando cuenta...' : 'Crear cuenta'}
              </button>
            </form>

            <div className="auth-divider">
              <span>o</span>
            </div>

            <button className="auth-google-button" onClick={handleGoogleLogin}>
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continuar con Google
            </button>
          </>
        )}

        <p className="auth-link" onClick={() => navigate(`/?redirect=${getRedirect()}`)}>
          ¿Ya tenés cuenta? Entrá
        </p>
      </div>
    </div>
  );
}

export default Register;